

































import { Component, Vue } from 'vue-property-decorator';
import { attachmentApis, MailAttachment } from '@/api/attachments.api';
import { LoginRequired } from '@/api/api_error';
import { formatterDatetime } from '@/common';

@Component
export default class AttachmentShardView extends Vue {
  attachmentUid = '';
  attachment: MailAttachment = {} as MailAttachment;
  loading = true;
  downloading = false;
  error = false;
  errorMessage = '您所访问的附件有误，请查看原始邮件确认';
  formatterDatetime = formatterDatetime;

  mounted() {
    this.attachment = {} as MailAttachment;
    this.attachmentUid = this.$route.query.uid?.toString() || '';
    if (!this.attachmentUid) {
      this.error = true;
      this.loading = false;
      return;
    }
    this.loadAttachment();
  }

  async loadAttachment() {
    try {
      this.loading = true;
      this.error = false;
      const response = await attachmentApis.getAttachmentInfo(this.attachmentUid);
      this.attachment = response;
    } catch (err) {
      if (err.message) {
        this.errorMessage = err.message;
      }
      console.error('Failed to load attachment:', err);
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  async downloadAttachment() {
    if (this.attachment) {
      this.downloading = true;
      try {
        const resp = await attachmentApis.getAttachmentDownloadLink(this.attachment.uid);
        const downloadUrl = resp.link;
        window.location.href = downloadUrl;
        return;
      } catch (error) {
        if (error instanceof LoginRequired) {
          this.errorMessage = '请登录后查看';
        } else {
          this.errorMessage = `获取下载链接失败${error.message}`;
          this.error = true;
        }
        return;
      } finally {
        this.downloading = false;
      }
    }
  }
}
